import React from 'react';
/* eslint-disable-next-line no-restricted-imports */
import { Router } from 'react-router-dom';
import ContextWrapper from './ContextWrapper';

/* eslint-disable-next-line no-restricted-imports */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Wraps react-router's Router children with context to support hooks (useLocation, useParams etc).
 * Check ./hooks/index.js for hooks implemetation.
 */
export const RouterWithContext = props => {
  const {
    children,
    history
  } = props;
  return /*#__PURE__*/_jsx(Router, {
    history: history,
    children: /*#__PURE__*/_jsx(ContextWrapper, {
      children: children
    })
  });
};